export const ERROR_MESSAGES = {
  ROOT_NOT_FOUND: "Root element not found!",
  SESSION_VALIDATION_FAILED: "Failed to validate session.",
  GENERIC_ERROR: "An error occurred. Status: ",
  policies: "Policies couldn’t be loaded. Check your connection or try again later.",
  legalRefs: "Legal references couldn’t be loaded. Check your connection or try again later.",
  LEGAL_REFERENCE_EXISTS: "This legal reference already exists.",
  LEGAL_REFERENCE_CREATION_FAILED: "Legal reference failed to create.",
  POLICY_FETCH_FAILED: "Policies couldn’t be loaded. Check your connection or try again later.",
  POLICY_FETCH_ERROR: "Policies couldn’t be loaded. Check your connection or try again later.",
  ERROR_FETCH_LEGAL_REFS: "Legal references couldn’t be loaded. Check your connection or try again later.",
};

export const INFO_MESSAGE ={
  LOADING_LABEL: "Loading legal references...",
  LOADING_MORE: "Loading...",
  SEARCH_PLACEHOLDER: "Search Legal References...",
  ADD_BUTTON_LABEL: "Add endnote reference",
  LOAD_MORE: "Load More",
}
export const SUCCESS_MESSAGES ={
  LEGAL_REFERENCE_CREATED: "Legal reference created",
}

export const WARNING_MESSAGES = {
  CURSOR_IN_REFERENCE_SECTION: "Please place your cursor in the document body, not in the cross-reference section.",
};

export const STATUS_CODES = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
};

export const PIVOT_STYLES = {
  root: { width: "100%" },
  link: {
    color: "#185abd",
    fontSize: 13,
    padding: "0 5px",
    maxWidth: "160px",
    height: 30,
    lineHeight: "30px",
    selectors: {
      span: {
        padding: 0,
        margin: 0,
        lineHeight: "30px",
        height: "30px",
        display: "inline-block",
        verticalAlign: "middle",
        paddingBottom: "5px",
      },
    },
  },
  linkIsSelected: {
    fontWeight: 600,
    fontSize: 13,
    padding: "0 5px",
    height: 30,
    lineHeight: "30px",
    selectors: {
      span: {
        padding: 0,
        margin: 0,
        lineHeight: "30px",
        height: "30px",
        paddingBottom: "5px",
      },
    },
  },
};

